import PropTypes from "prop-types";

export const Chevron = ({ className = "accordion-icon", ...rest }) => {
  return (
    <svg
      width="10px"
      height="6px"
      viewBox="0 0 10 6"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-56.000000, -9.000000)"
          fill="#242424"
          fillRule="nonzero"
        >
          <path d="M61,14.9622437 C61.0868403,14.9622437 61.1636607,14.9288436 61.2304609,14.8620433 L61.2304609,14.8620433 L65.8997996,10.1927046 C65.9665999,10.1259043 66,10.049084 66,9.96224368 C66,9.87540334 65.9665999,9.79858303 65.8997996,9.73178276 L65.8997996,9.73178276 L65.3987976,9.23078076 C65.3319973,9.16398049 65.255177,9.13058036 65.1683367,9.13058036 C65.0814963,9.13058036 65.004676,9.16398049 64.9378758,9.23078076 L64.9378758,9.23078076 L61,13.1686565 L57.0621242,9.23078076 C56.995324,9.16398049 56.9185037,9.13058036 56.8316633,9.13058036 C56.744823,9.13058036 56.6680027,9.16398049 56.6012024,9.23078076 L56.6012024,9.23078076 L56.1002004,9.73178276 C56.0334001,9.79858303 56,9.87540334 56,9.96224368 C56,10.049084 56.0334001,10.1259043 56.1002004,10.1927046 L56.1002004,10.1927046 L60.7695391,14.8620433 C60.8363393,14.9288436 60.9131597,14.9622437 61,14.9622437 Z"></path>
        </g>
      </g>
    </svg>
  );
};

Chevron.propTypes = {
  className: PropTypes.string,
};
